const isTrue = (x) => [true, "true", 1, "1"].includes(x);

const isFalse = (x) => ["false", false, "0", 0].includes(x);

export const isBooleanEqual = (valA, valB) => {
  return (isTrue(valA) && isTrue(valB)) || (isFalse(valA) && isFalse(valB));
};
